import { useEffect } from "react";
import useDelayedState from "use-delayed-state";

import useCGIGRP2 from "./useCGIGRP2";

export default function useCGIGRP2LoginStatus() {
  const [tick, setTick] = useDelayedState(0);
  const { data, loading, error } = useCGIGRP2(
    "/login",
    { cachePolicy: "no-cache" },
    [tick],
  );
  useEffect(() => {
    if (!loading && !data?.grpFault) {
      setTick((tick) => tick + 1, 1000);
    }
  }, [loading, data?.grpFault]);

  return { loading, error, ...data };
}
